import { getDiamGroupId } from '~/domain/uptime/utils/utils';
import Path from './Path/Path';

const localeRegex = '[A-z]{2}-[A-z]{2}';
const diamGroupId = getDiamGroupId();

const appendOptionalUptimePrefix = (relative: string) => {
  const prefix = diamGroupId === undefined ? '' : `/uptime/${diamGroupId}`;
  return `${prefix}${relative}`;
};

const paths = {
  /* Public */
  acceptUserInvite: new Path<{ locale: string; inviteId: string }>(
    `/:locale(${localeRegex})/accept-user-invite/:inviteId`
  ),
  app: new Path('/app'),
  cookiePolicy: new Path('/cookie-policy'),
  login: new Path('/login'),
  uptimeCallback: new Path('/uptime/callback'),
  uptimeLogout: new Path('/uptime/logout'),
  oidcCallback: new Path('/oidc/callback'),
  logout: new Path('/logout'),
  operator: new Path('/operator'),
  register: new Path<{ locale: string; inviteId: string }>(
    `/:locale(${localeRegex})/register/:inviteId`
  ),
  salesCompanyLogin: new Path('/login/salescompany'),
  signup: new Path<{ locale?: string }>(`/:locale(${localeRegex})?/signup`),
  signupComplete: new Path('/signup/complete'),
  signupSuccess: new Path('/signup/success'),
  uiKit: new Path('/ui-kit'),
  translations: new Path<{ locale: string }>('/translations/:locale'),

  /* Secured */
  companySettings: new Path<{ subpage: 'account' | 'subscription' }>('/company-settings/:subpage?'),
  changelog: new Path('/changelog'),
  dashboard: new Path(appendOptionalUptimePrefix('/dashboard')),
  dataExports: new Path('/data-exports'),
  dealerAccess: new Path('/dealer-access'),
  gateways: new Path('/gateways'),
  legal: new Path('/legal'),
  machines: new Path<{ machineId?: string }>('/machines/:machineId?'),
  inventory: new Path<{ machineId?: string }>(
    appendOptionalUptimePrefix('/inventory/:machineId?/:sectionType?')
  ),
  roboticInstallation: new Path<{ machineId: string; settingCode: string }>(
    '/inventory/:machineId/installation/:settingCode'
  ),
  getMachinesOrInventory: (): typeof paths.machines | typeof paths.inventory => {
    return Reflect.get(paths, 'inventory');
  },

  people: new Path<{ user_role: string }>('/people/:user_role'),
  settings: new Path('/settings'),
  users: new Path<{ user_role: string }>('/users/:user_role'),
  enableUsersAndAccess: new Path('/users_access_enable'),
  usersAndAccess: new Path<{ subpage: 'users' | 'access' }>('/users_access/:subpage?'),
  getPeopleOrUsers: (): typeof paths.users => {
    return Reflect.get(paths, 'users');
  },
  analytics: new Path('/analytics'),

  /* SalesCompany */
  companies: new Path<{
    companyType?: 'internal' | 'commercial';
    companyId?: string;
  }>('/companies/:companyType?/:companyId?'),

  // Greenkeeper tool
  greenkeeper: new Path('/greenkeeper/*'),
  greenkeeperRoot: new Path('/greenkeeper/'),
  greenkeeperFairways: new Path('/greenkeeper/fairways'),
  greenkeeperLogActivities: new Path('/greenkeeper/log-activities'),
  greenkeeperTasks: new Path('/greenkeeper/tasks'),
  inviteRequests: new Path<{ status: 'approved' }>('/inviterequests/:status'),
};

export const deprecatedPaths = {
  createInvite: new Path('/:locale?/invite'),
};

export default paths;
